module.exports = __webpack_public_path__ + "assets/images/project/ttsh/mobile.svg?v=cd27a402";